import { createContext, useContext } from 'react';

const SelectedDataContext = createContext({ selectedData: [] });

const SelectedDataProvider = SelectedDataContext.Provider;
const SelectedDataConsumer = SelectedDataContext.Consumer;
const useSelectedData = () => useContext(SelectedDataContext);

export { SelectedDataProvider, SelectedDataConsumer, useSelectedData };
